export const stats = [
  { value: "186万+", label: "在线吃瓜群众", icon: "ri-user-heart-line" },
  { value: "3.2万", label: "今日热门话题", icon: "ri-fire-line" },
  { value: "92万+", label: "实时跟帖热议", icon: "ri-chat-voice-line" },
  { value: "7×24", label: "不间断围观直播", icon: "ri-live-line" },
];

export interface RankItem {
  id: number;
  rank: number;
  tag: string;
  title: string;
  hot: string;
  replies: string;
  trend: "up" | "down" | "new";
}

export const trendingList: RankItem[] = [
  { id: 1, rank: 1, tag: "全网热榜", title: "新剧开播第一集收视口碑两极，主创连夜直播回应争议", hot: "982万", replies: "4.6万", trend: "up" },
  { id: 2, rank: 2, tag: "吃瓜现场", title: "品牌直播间一句口误冲上热搜，粉丝开始考古十年前旧账", hot: "761万", replies: "3.2万", trend: "new" },
  { id: 3, rank: 3, tag: "灌水热聊", title: "网友晒出同一栋楼的电梯日常，评论区秒变情景剧连载", hot: "654万", replies: "2.9万", trend: "up" },
  { id: 4, rank: 4, tag: "爆料解读", title: "决赛夜临场换将引热议，吧友逐帧复盘比分背后的细节", hot: "543万", replies: "2.4万", trend: "down" },
  { id: 5, rank: 5, tag: "八卦闲聊", title: "全网都在晒童年零食，情怀帖一小时盖了八千层楼", hot: "431万", replies: "1.8万", trend: "up" },
  { id: 6, rank: 6, tag: "现场实况", title: "音乐节现场直拍流出一段爆音，官方回应正在检修设备", hot: "377万", replies: "1.5万", trend: "new" },
  { id: 7, rank: 7, tag: "话题广场", title: "打工人午休的最后一小时，如何体面地摸鱼不背锅", hot: "289万", replies: "1.1万", trend: "down" },
  { id: 8, rank: 8, tag: "吃瓜现场", title: "婚礼现场互换誓词临场加戏，台下亲友笑到直不起腰", hot: "214万", replies: "9.8千", trend: "up" },
];

export interface Board {
  id: number;
  name: string;
  slug: string;
  desc: string;
  posts: string;
  members: string;
  tone: string;
  icon: string;
}

export const boards: Board[] = [
  { id: 1, name: "全网评论区", slug: "comment", desc: "大事小事都能吵，站队之前先看看不同视角怎么说。", posts: "28.6万帖", members: "63万", tone: "primary", icon: "ri-chat-3-line" },
  { id: 2, name: "话题广场", slug: "topic", desc: "从热搜到生活小事，热门讨论都在这里等你去发声。", posts: "31.2万帖", members: "88万", tone: "secondary", icon: "ri-question-answer-line" },
  { id: 3, name: "讨论版块", slug: "discuss", desc: "深挖事件的来龙去脉，理性吃瓜也要摆事实讲逻辑。", posts: "17.9万帖", members: "42万", tone: "accent", icon: "ri-message-2-line" },
  { id: 4, name: "灌水区", slug: "water", desc: "闲来无事随便聊，想说什么就说什么，快乐最重要。", posts: "52.4万帖", members: "120万", tone: "secondary", icon: "ri-donut-chart-fill" },
  { id: 5, name: "爆料速递", slug: "leak", desc: "最新线索与内幕解读，坐等楼主带你抽丝剥茧看真相。", posts: "9.3万帖", members: "31万", tone: "primary", icon: "ri-flashlight-line" },
  { id: 6, name: "吃瓜现场", slug: "live", desc: "事件进展随时更新，边看直播边和瓜友实时互通有无。", posts: "14.7万帖", members: "57万", tone: "accent", icon: "ri-live-fill" },
];

export interface FeedItem {
  id: number;
  board: string;
  title: string;
  summary: string;
  author: string;
  avatar: string;
  avatarHue: string;
  time: string;
  likes: string;
  comments: string;
  featured?: boolean;
}

export const feedItems: FeedItem[] = [
  {
    id: 1, board: "话题广场", featured: true,
    title: "新综艺主题曲一公开，听众立刻分成“上头”和“劝退”两派",
    summary: "旋律一响，评论区直接炸开锅。有人循环播放停不下来，有人觉得编曲节奏别扭。为了这首主题曲到底值不值得追，大家在话题广场里吵了整整三天，还搬出编曲人历年作品逐条对比，硬是把冷门知识讨论成了科普现场。",
    author: "一只耳边的风", avatar: "FF5A3C", avatarHue: "primary", time: "18 分钟前", likes: "1.2万", comments: "3860",
  },
  {
    id: 2, board: "爆料速递",
    title: "网红小吃摊排队两小时，吧友实测后晒出同款替代攻略",
    summary: "有人发帖吐槽排队太久还吃不到，热心瓜友直接甩出同城三家平替配方和位置，评论区秒变美食地图，连摊主都潜水冒泡回应感谢。",
    author: "干饭第一名", avatar: "2BB673", avatarHue: "secondary", time: "1 小时前", likes: "8.7千", comments: "2210",
  },
  {
    id: 3, board: "灌水区",
    title: "深夜求助：养了八年的猫开始嫌弃我的审美，怎么办？",
    summary: "楼主晒出被猫扒拉坏的地毯，配文一把辛酸泪。结果楼下全在晒自家主子改造家装的“案发现场”，越聊越离谱，楼已经歪到宠物心理学的深度。",
    author: "熬夜冠军", avatar: "F6A821", avatarHue: "accent", time: "2 小时前", likes: "6.3千", comments: "1874",
  },
  {
    id: 4, board: "讨论版块",
    title: "一场演唱会的票价贵不贵，到底该由谁说了算？",
    summary: "从黄牛价聊到主办方成本，从粉丝经济聊到理性消费。这场讨论没有标准答案，但瓜友们的发言里藏着不少看待问题的独特角度，值得一页页翻完。",
    author: "理中客小蓝", avatar: "E85D75", avatarHue: "primary", time: "4 小时前", likes: "5.1千", comments: "1430",
  },
  {
    id: 5, board: "吃瓜现场",
    title: "年度颁奖礼红毯路透抢先看，谁的造型惊艳到你？",
    summary: "红毯还没开始，场外路透已经先聊起来了。有人整理出一份造型对比帖，从服装到妆发逐一点评，网友一边看一边给今年的最佳穿搭投票。",
    author: "现场小蜜蜂", avatar: "2A9D8F", avatarHue: "secondary", time: "5 小时前", likes: "4.4千", comments: "1120",
  },
  {
    id: 6, board: "全网评论区",
    title: "外卖小哥超时被差评，评论区有人力挺也有人站队店家",
    summary: "一个差评把责任归属聊成了哲学问题。评论区一边心疼小哥的辛苦，一边也在讨论平台规则和店家经营。理性跟帖越来越多，楼里的火药味渐渐变成了互相理解。",
    author: "热心市民刘叔", avatar: "E76F51", avatarHue: "accent", time: "7 小时前", likes: "3.9千", comments: "980",
  },
];

export interface Testimonial {
  id: number;
  name: string;
  role: string;
  quote: string;
  avatarHue: string;
  stars: number;
}

export const testimonials: Testimonial[] = [
  { id: 1, name: "追剧的小满", role: "在瓜 3 年", quote: "这里的信息真的很及时，刚上热搜的事，几分钟后版块里就已经有层层分析帖了。作为吃瓜群众，最快乐的就是不用翻遍全平台才能拼出完整故事。", avatarHue: "primary", stars: 5 },
  { id: 2, name: "咖啡不加糖", role: "在瓜 2 年", quote: "氛围是我最喜欢的部分。热榜聊得再凶，也总有人愿意摆事实讲道理，版主维护得也上心，该沉的沉、该置顶的置顶，不乱也不脏。", avatarHue: "secondary", stars: 5 },
  { id: 3, name: "一只吃瓜的猫", role: "在瓜 1 年", quote: "灌水区真的是我的快乐老家，随手发个无聊日常也能被楼里的小伙伴接梗接到飞起，压力大的时候来逛一圈心情都会好很多。", avatarHue: "accent", stars: 5 },
];

export const rules = [
  { icon: "ri-shield-check-line", title: "理性吃瓜", desc: "围观不站队，发言摆事实，拒绝无脑拉踩与人参公鸡。" },
  { icon: "ri-eye-off-line", title: "尊重隐私", desc: "不传播他人隐私与未经证实信息，点到为止不越界。" },
  { icon: "ri-emotion-laugh-line", title: "快乐第一", desc: "闲聊也有温度，让每个版块都值得常来常往。" },
  { icon: "ri-megaphone-line", title: "举报直达", desc: "看到违规内容一键举报，版务团队 24 小时内跟进。" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  { q: "吃瓜聚集是什么？", a: "吃瓜聚集是一个面向全网网友的开放式讨论互动社区，把评论区、话题广场、讨论版块和灌水区汇集到一处。你可以在这里围观热门事件、参与话题讨论、分享第一手见闻，也能随手发帖和陌生网友畅聊，找到属于自己的表达空间。" },
  { q: "浏览内容需要注册账号吗？", a: "不强制。绝大部分热榜、话题和帖子都可以直接围观浏览。如果你想参与跟帖、发帖或在话题广场投票表达态度，再注册一个轻量账号即可，整个过程不需要复杂资料。" },
  { q: "如何判断一条信息的可信度？", a: "社区提倡来源优先：官方公告、当事人回应、现场实拍相对更可靠。对于标为“爆料/猜测”的内容，我们建议你结合多方信息自行判断，看到明显违规或造谣的帖子也可以点击举报。" },
  { q: "灌水区和正式讨论版块有什么区别？", a: "灌水区主打轻松闲聊，可以放飞自我、接梗抖机灵；正式讨论版块则更侧重事件梳理和观点交锋。两类空间入口相同，内容节奏不同，逛的时候按心情切换就好。" },
  { q: "怎样参与话题广场的热门讨论？", a: "进入对应话题页，在底部输入框发表你的看法即可。点赞、收藏、转发都能让好内容被更多人看到。讨论激烈的话题会自动提升热度，登上话题广场的推荐位。" },
  { q: "遇到人身攻击或造谣内容该怎么处理？", a: "每一条帖子和回复都带举报入口。提交后版务团队会按社区公约在 24 小时内审核处理，情节严重的会直接删除并限制账号发言，确保讨论氛围健康可控。" },
];